import React, { useState, useEffect } from "react";
import apiService from "apiService";
import Select2 from "react-select";
import Alert from "view/component/Alert";
import "react-datepicker/dist/react-datepicker.css";

const DrugInformation = (props) => {
  const [param, setParam] = useState({
    visit_id: props.detilPx.id,
    id: null,
    method: 0,
    methods: {
      value: 0,
      label: "Lisan",
    },
    patient_stat: 0,
    patient_stats: {
      value: 0,
      label: "Pasien",
    },
    answer_delay: 0,
    answer_delays: {
      value: 0,
      label: "Segera",
    },
    question: "",
    answer: "",
    reference: "",
    drugs_identification: false,
    drugs_interaction: false,
    drugs_price: false,
    contra_indication: false,
    usage: false,
    stability: false,
    dosage: false,
    toxication: false,
    side_effect: false,
    therapeutic: false,
    pharmacokinetic: false,
    pharmacodynamic: false,
    availability: false,
    drugs_name: false,
    storage: false,
    indication: false,
    et_cetera: "",
  });

  const getDrugInformation = async () => {
    let res = await apiService.get(
      "/registration/drugs_informations/read/" + props.detilPx.id
    );
    if (res && res.code === 200) {
      setParam({
        ...param,
        id: res.data.id,
        method: res.data.method,
        patient_stat: res.data.patient_stat,
        answer_delay: res.data.answer_delay,
        question: res.data.question,
        answer: res.data.answer,
        reference: res.data.reference,
        drugs_identification: res.data.drugs_identification,
        drugs_interaction: res.data.drugs_interaction,
        drugs_price: res.data.drugs_price,
        contra_indication: res.data.contra_indication,
        usage: res.data.usage,
        stability: res.data.stability,
        dosage: res.data.dosage,
        toxication: res.data.toxication,
        side_effect: res.data.side_effect,
        therapeutic: res.data.therapeutic,
        pharmacokinetic: res.data.pharmacokinetic,
        pharmacodynamic: res.data.pharmacodynamic,
        availability: res.data.availability,
        drugs_name: res.data.drugs_name,
        storage: res.data.storage,
        indication: res.data.indication,
        et_cetera: res.data.et_cetera,
        methods: {
          value: res.data.method,
          label:
            res.data.method === 0
              ? "Lisan"
              : res.data.method === 1
              ? "Tertulis"
              : "Telepon",
        },
        patient_stats: {
          value: res.data.patient_stat,
          label:
            res.data.patient_stat === 0
              ? "Pasien"
              : res.data.patient_stat === 1
              ? "Petugas Kesehatan"
              : "Keluarga Pasien",
        },
        answer_delays: {
          value: res.data.answer_delay,
          label:
            res.data.answer_delay === 0
              ? "Segera"
              : res.data.answer_delay === 1
              ? "Dalam 24 Jam"
              : "Lebih dari 24 Jam",
        },
      });
    }
  };

  useEffect(() => {
    getDrugInformation();
  }, [param.length]);

  const postParam = async () => {
    let res;
    if (param.id)
      res = await apiService.put(
        "/registration/drugs_informations/update",
        param
      );
    else
      res = await apiService.post(
        "/registration/drugs_informations/create",
        param
      );
    if (res.code === 200) {
      Alert("success", "data disimpan");
    } else {
      Alert("error", "gagal menyimpan data");
    }
    getDrugInformation();
  };

  return (
    <div>
      <div className='card'>
        <div className='card-header'>
          <div className='row align-items-center'>
            <div className='col'>
              <h4 className='h3 mb-0'>Form Pelayanan Informasi Obat</h4>
            </div>
          </div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Metode
                </label>
                <Select2
                  className='form-control p-0 pt-1'
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      backgroundColor: "white",
                      border: "none",
                    }),
                  }}
                  value={param.methods}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      method: e.value,
                      methods: e,
                    })
                  }
                  options={[
                    {
                      value: 0,
                      label: "Lisan",
                    },
                    {
                      value: 1,
                      label: "Tertulis",
                    },
                    {
                      value: 2,
                      label: "Telepon",
                    },
                  ]}
                />
              </div>
            </div>
            <div className='col-md-4'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Status
                </label>
                <Select2
                  className='form-control p-0 pt-1'
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      backgroundColor: "white",
                      border: "none",
                    }),
                  }}
                  value={param.patient_stats}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      patient_stat: e.value,
                      patient_stats: e,
                    })
                  }
                  options={[
                    {
                      value: 0,
                      label: "Pasien",
                    },
                    {
                      value: 1,
                      label: "Petugas Kesehatan",
                    },
                    {
                      value: 2,
                      label: "Keluarga Pasien",
                    },
                  ]}
                />
              </div>
            </div>
            <div className='col-md-4'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Penyampaian Jawaban
                </label>
                <Select2
                  className='form-control p-0 pt-1'
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      backgroundColor: "white",
                      border: "none",
                    }),
                  }}
                  value={param.answer_delays}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      answer_delay: e.value,
                      answer_delays: e,
                    })
                  }
                  options={[
                    {
                      value: 0,
                      label: "Segera",
                    },
                    {
                      value: 1,
                      label: "Dalam 24 Jam",
                    },
                    {
                      value: 2,
                      label: "Lebih dari 24 Jam",
                    },
                  ]}
                />
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Pertanyaan
                </label>
                <textarea
                  className='form-control'
                  onChange={(e) =>
                    setParam({ ...param, question: e.target.value })
                  }
                  rows='3'
                  value={param.question}
                />
              </div>
            </div>
            <div className='col-12'>
              <label className='form-control-label text-default'>
                Pemberian Informasi
              </label>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck1'
                  checked={param.drugs_name ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, drugs_name: !param.drugs_name })
                  }
                />
                <label class='custom-control-label' for='customCheck1'>
                  Nama Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck2'
                  checked={param.storage ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, storage: !param.storage })
                  }
                />
                <label class='custom-control-label' for='customCheck2'>
                  Penyimpanan
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck3'
                  checked={param.indication ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, indication: !param.indication })
                  }
                />
                <label class='custom-control-label' for='customCheck3'>
                  Indikasi
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck16'
                  checked={param.drugs_identification ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      drugs_identification: !param.drugs_identification,
                    })
                  }
                />
                <label class='custom-control-label' for='customCheck16'>
                  Identifikasi Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck4'
                  checked={param.stability ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, stability: !param.stability })
                  }
                />
                <label class='custom-control-label' for='customCheck4'>
                  Stabilitas
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck5'
                  checked={param.pharmacokinetic ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      pharmacokinetic: !param.pharmacokinetic,
                    })
                  }
                />
                <label class='custom-control-label' for='customCheck5'>
                  Farmakokinetika
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck6'
                  checked={param.drugs_interaction ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      drugs_interaction: !param.drugs_interaction,
                    })
                  }
                />
                <label class='custom-control-label' for='customCheck6'>
                  Interaksi Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck7'
                  checked={param.dosage ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, dosage: !param.dosage })
                  }
                />
                <label class='custom-control-label' for='customCheck7'>
                  Dosis
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck8'
                  checked={param.pharmacodynamic ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({
                      ...param,
                      pharmacodynamic: !param.pharmacodynamic,
                    })
                  }
                />
                <label class='custom-control-label' for='customCheck8'>
                  Farmakodinamika
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.drugs_price ? 'checked' : ''}
                  id='customCheck9'
                  onChange={(e) =>
                    setParam({ ...param, drugs_price: !param.drugs_price })
                  }
                />
                <label class='custom-control-label' for='customCheck9'>
                  Harga Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.toxication ? 'checked' : ''}
                  id='customCheck10'
                  onChange={(e) =>
                    setParam({ ...param, toxication: !param.toxication })
                  }
                />
                <label class='custom-control-label' for='customCheck10'>
                  Keracunan
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.availability ? 'checked' : ''}
                  id='customCheck11'
                  onChange={(e) =>
                    setParam({ ...param, availability: !param.availability })
                  }
                />
                <label class='custom-control-label' for='customCheck11'>
                  Ketersediaan Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.contra_indication ? 'checked' : ''}
                  id='customCheck12'
                  onChange={(e) =>
                    setParam({
                      ...param,
                      contra_indication: !param.contra_indication,
                    })
                  }
                />
                <label class='custom-control-label' for='customCheck12'>
                  Kontra Indikasi
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.side_effect ? 'checked' : ''}
                  id='customCheck13'
                  onChange={(e) =>
                    setParam({ ...param, side_effect: !param.side_effect })
                  }
                />
                <label class='custom-control-label' for='customCheck13'>
                  Efek Samping Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.usage ? 'checked' : ''}
                  id='customCheck14'
                  onChange={(e) => setParam({ ...param, usage: !param.usage })}
                />
                <label class='custom-control-label' for='customCheck14'>
                  Cara Pemakaian
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-2'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck15'
                  checked={param.therapeutic ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, therapeutic: !param.therapeutic })
                  }
                />
                <label class='custom-control-label' for='customCheck15'>
                  Penggunaan Terapeutik
                </label>
              </div>
            </div>
            <div className='col-md-8'>
              <div class='form-group'>
                <div class='input-group input-group-sm'>
                  <div class='input-group-prepend'>
                    <span class='input-group-text bg-secondary text-sm text-default border-light'>
                      Informasi Lainnya
                    </span>
                  </div>
                  <input
                    type='text'
                    class='form-control text-default border-light'
                    placeholder='Pemberian informasi lainnya'
                    onChange={(e) =>
                      setParam({ ...param, et_cetera: e.target.value })
                    }
                    value={param.et_cetera}
                  />
                </div>
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Jawaban
                </label>
                <textarea
                  className='form-control'
                  onChange={(e) =>
                    setParam({ ...param, answer: e.target.value })
                  }
                  rows='3'
                  value={param.answer}
                />
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Referensi
                </label>
                <textarea
                  className='form-control'
                  onChange={(e) =>
                    setParam({ ...param, reference: e.target.value })
                  }
                  rows='1'
                  value={param.reference}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='card-footer'>
          <div className='btn btn-primary' onClick={() => postParam()}>
            Simpan PIO
          </div>
        </div>
      </div>
      {/* <div className='accordion' id='accordionLog'>
        <div className='card'>
          <div
            className='card-header'
            id={"heading"}
            data-toggle='collapse'
            data-target={"#collapse"}
            aria-expanded='false'
            aria-controls={"collapse"}>
            <div className='h3 text-default mb-0'>Log Riwayat Kehamilan</div>
          </div>
          <div
            id={"collapse"}
            className='collapse'
            aria-labelledby={"heading"}
            data-parent='#accordionLog'>
            <div className='card-body bg-light'>
              <div className='accordion'></div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default DrugInformation;
